import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const mapListEtagSelector = (state: AppState) => state.frontendState.mapListing.eTag;
export const useMapListETagSelector = () => useSelector(mapListEtagSelector);

const mapListSearchQuerySelector = (state: AppState) => state.frontendState.mapListing.searchQuery;
export const useMapListSearchQuerySelector = () => useSelector(mapListSearchQuerySelector);
